import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Observable, catchError} from 'rxjs';
import {InvoiceType} from '../model/invoice-type';

@Injectable({
  providedIn: 'root'
})

export class InvoiceTypeService {
  private resourcePath: string = 'dbov2/invoice-type';

  private http = inject(HttpClient);


  getInvoicesType(params?: Record<string, string>): Observable<InvoiceType[]> {
    return this.http
        .get<InvoiceType[]>(`${this.resourcePath}`, {params})
        .pipe(catchError((error:HttpErrorResponse)=>{
            throw new Error(error?.message || 'Server error');
        }));
  }
}